import React from 'react'
import "./ProdSliderComp.css"
import Prod1 from "../../../../assets/imgs/product/prodImg.jpeg"

function ProdSliderComp(props) {
  return (
   
    <div className='psc'>

    <img  src={Prod1} alt='Prod' />
    <div  className='p-blur'><button onClick={props.handleView}>Click</button></div>
  </div>

  )
}

export default ProdSliderComp
